<div class="card-body ">
  <div *ngFor="let product of products">
    <h3>{{ product.name }} - test</h3>
    <img [src]="image" alt="{{ product.name }}" *ngFor="let image of product.images" style="max-width: 100px;">
    <div *ngFor="let price of product.prices">
      <p>{{ price.unit_amount | currency }}</p>
    </div>
  </div>
  <form class="form">
    <mat-form-field class="example-full-width">
      <mat-label>
        {{ 'Your name' | translate }}
      </mat-label>
      <input formControlName="name" matInput type="text" />
      <mat-icon matSuffix fontSet="material-icons-outlined" class="input-icon">account_circle</mat-icon>
    </mat-form-field>
    <mat-form-field class="example-full-width">
      <mat-label>
        {{ 'E-mail address' | translate }}
      </mat-label>
      <input formControlName="email" matInput type="email" email />
      <mat-icon matSuffix fontSet="material-icons-outlined" class="input-icon">email</mat-icon>
    </mat-form-field>
    <mat-form-field class="example-full-width">
      <mat-label>{{ 'Password' | translate }}
      </mat-label>
      <input formControlName="password" matInput type="password" />
      <mat-icon matSuffix class="input-icon">lock_outline</mat-icon>
    </mat-form-field>
    <button type="submit" class="btn btn-primary  col-sm-12"> {{'Register'| translate}} </button>
    <button type="button" class="btn btn-primary col-12"> {{'Resend verification email' | translate}} </button>
    <button type="submit" class="btn btn-success col-12"> {{'Log In' | translate }} </button>
    <button type="button" class="btn btn-primary  col-sm-12"> {{'Reset my password' | translate}} </button>
  </form>
  </div>